import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, space, zIndices, fontSizes } = theme

export const Hero = styled.section`
  position: relative;
  background-color: ${colors['neutral-background-default']};
  padding-top: ${space['spacing-md']};
  overflow: hidden;

  @media (${media.tablet}) {
    padding-top: ${space['spacing-xxxl']};
    padding-bottom: ${space['spacing-xxxl']};
    overflow: visible;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  margin-left: ${space['spacing-md']};
`

export const Infos = styled.div`
  position: relative;
  z-index: ${zIndices[1]};

  h1 {
    margin-bottom: ${space['spacing-sm']};
  }

  .hero-description {
    margin-bottom: ${space['spacing-md']};
  }

  .text-credit {
    margin-bottom: ${space['spacing-xxxs']};
  }

  .text-value {
    margin-bottom: 0;
  }

  .list-title {
    margin-bottom: ${space['spacing-md']};
  }

  @media (${media.tablet}) {
    top: 32px;
    margin-bottom: ${space['spacing-md']};

    .hero-description {
      margin-bottom: ${space['spacing-xxl']};
    }

    .ds-button {
      width: 19rem;
    }
  }

  @media (${media.desktop}) {
    h1 {
      font-size: ${fontSizes['font-size-heading-2']};
    }
  }
`

export const LoanInfos = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${space['spacing-md']};
  margin-top: ${space['spacing-md']};

  @media (${media.tablet}) {
    gap: ${space['spacing-sm']};
    margin-bottom: ${space['spacing-xl']};
  }
`

export const LoanInfosItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};
`
